import { css } from '@emotion/react';

export const styles = {
  wrapper: css`
    padding: 0 80px 80px;
    background: #ffffff;
  `,
  grid: css`
    display: grid;
    grid-template-columns: 320px 1fr;
    gap: 32px;
    align-items: start;
  `,
  rightColumn: css`
    min-width: 0;
  `,
  errorBox: css`
    margin-bottom: 16px;
    padding: 14px 16px;
    border-radius: 12px;
    background: rgba(180, 35, 24, 0.08);
    color: #b42318;
    font-size: 14px;
    line-height: 1.5;
  `,
  noVacancies: css`
    width: 100%;
    padding: 40px 0 80px;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    color: #111827;
  `,
};
